import { css } from 'linaria'
import theme from '../../../../../styles/theme'

const classes = {
    warningContainer: css`
    display: flex;
    align-items: flex-start;
    margin-top: -${theme.spacing(3)}px;
    `,
    warningContent: css`
    flex: 1;
    `,
    warningTitle: css`
    font-weight: 600;
    color: ${theme.palette.primary.main};
    margin-bottom: ${theme.spacing(1)}px;
    `,
    warningText: css`
    color: ${theme.palette.primary.main};
    margin-bottom: ${theme.spacing(2)}px;
    line-height: 1.4;
    `,
    requirementsList: css`
    margin: ${theme.spacing(2)}px 0;
    padding-left: ${theme.spacing(3)}px;
    color: ${theme.palette.primary.main};
    
    li {
        margin-bottom: ${theme.spacing(1)}px;
        line-height: 1.4;
    }
    `,
    radioGroup: css`
    margin-top: ${theme.spacing(2)}px;
    margin-bottom: -${theme.spacing(2)}px;

    ${theme.breakpoints.down('sm')} {
        margin-bottom: -${theme.spacing(5)}px;
    }
    
    .MuiFormControlLabel-root {
        margin-right: ${theme.spacing(3)}px;
    }
    
    .MuiRadio-root, .MuiRadio-colorSecondary.Mui-checked {
        color: ${theme.palette.primary.main};
    }
    `,
    chatSection: css`
    background-color: #FEBD1766;
    padding: ${theme.spacing(2)}px;
    border-radius: 20px;
    border: 1px solid #FEBD17;
    margin-top: -${theme.spacing(2)}px;
    margin-bottom: -${theme.spacing(2)}px;
    
    ${theme.breakpoints.down('sm')} {
        margin-top: ${theme.spacing(2)}px;
    }
    `,
    chatTitle: css`
    color: #524658;
    font-weight: 500;
    margin-bottom: ${theme.spacing(1)}px;
    `,
    chatText: css`
    color: #524658;
    line-height: 1.4;
    
    span {
        color: #17ab33;
        font-weight: 500;
    }
    
    a {
        color: #17ab33;
        font-weight: 500;
        text-decoration: underline;
    }
    `,
}

export default classes
